import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Tab } from "@headlessui/react";
import { getAdminAlerts } from "redux/slices/getAdminAlertsSlice";
import ActiveAlert from "./ActiveAlert";
import ExpiredAlert from "./ExpiredAlert";
import LoadingOverlay from "react-loading-overlay";
import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";
import { useTranslation } from "react-i18next";

export default function Alerts() {
  LoadingOverlay.propTypes = undefined;
  const dispatch = useDispatch();
  const { csrAlerts, isLoading } = useSelector((s) => s.csrAlerts);

  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [alertError, setAlertError] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    dispatch(getAdminAlerts())
      .then((response) => {
        if (response?.meta?.requestStatus !== "fulfilled") {
          setAlertError(true);
        }
      })
      .catch(() => {
        setAlertError(true);
      });
  }, []);

  const alerts =
    csrAlerts?.activeAlerts || csrAlerts?.expiredAlerts
      ? csrAlerts
      : { activeAlerts: [], expiredAlerts: [] };

  return (
    <div className="container">
      <Tab.Group>
        <div className="ui-card flex-grow px-2 p-1 md:px-4">
          <Tab.List>
            <Tab
              className={`text-sm mx-3 pt-3 pb-2 mb-1 md:text-base md:mx-4 lg:text-lg ${
                selectedTabIndex === 0 ? "" : "text-ui-blue"
              }`}
              onClick={() => {
                setSelectedTabIndex(0);
              }}
            >
              {t("AgentCSR-Admin-Alerts-title-1")}
            </Tab>
            <Tab
              className={`text-sm mx-3 pt-3 pb-2 mb-1 md:text-base md:mx-4 lg:text-lg ${
                selectedTabIndex === 1 ? "" : "text-ui-blue"
              }`}
              onClick={() => {
                setSelectedTabIndex(1);
              }}
            >
              {t("AgentCSR-Admin-Alerts-title-2")}
            </Tab>
          </Tab.List>
        </div>

        <Tab.Panels>
          <EverlakeLoadingOverlay isLoading={isLoading}>
            <ActiveAlert
              alerts={alerts?.activeAlerts}
              alertError={alertError}
            />
            <ExpiredAlert
              alerts={alerts?.expiredAlerts}
              alertError={alertError}
            />
          </EverlakeLoadingOverlay>
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
}
